import React, { useState } from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';
import { getAllLabelsForIndex } from 'helper/Meteorology/climateIndicesLabels';
import { IndiceClimaticoField } from 'types/Meteorology/indicesClimaticos';
import { SimilarityIndexFilters } from 'hooks/Meteorology/Agro/Similarity/Mobile/useSimilarityMobile';
import INDICES from '../indices';

import './index.scss';

export interface FiltersSheetProps {
  open: boolean;
  dismiss: () => void;
  filters: SimilarityIndexFilters;
  onToggle: (indexId: IndiceClimaticoField, label: string) => void;
  onClear: () => void;
  resultCount: number;
}

export default function FiltersSheet({
  open,
  dismiss,
  filters,
  onToggle,
  onClear,
  resultCount,
}: FiltersSheetProps) {
  const [openGroup, setOpenGroup] = useState<IndiceClimaticoField | null>(null);

  return (
    <BottomSheet open={open} dismiss={dismiss} title="Filtros" className="agro-simil-filters-sheet">
      <div className="agro-simil-filters-sheet-body">
        {INDICES.map(({ id, label, type }) => {
          const selected = filters[id] || [];
          return (
            <Section
              key={id}
              label={label}
              valueText={selected.length > 0 ? String(selected.length) : undefined}
              open={openGroup === id}
              onToggle={() => setOpenGroup(openGroup === id ? null : id)}
            >
              {getAllLabelsForIndex(type).map((optionLabel) => (
                <OptionRow
                  key={optionLabel}
                  label={optionLabel}
                  selected={selected.includes(optionLabel)}
                  selectionType="multiple"
                  onSelect={() => onToggle(id, optionLabel)}
                />
              ))}
            </Section>
          );
        })}
      </div>

      <div className="agro-simil-filters-sheet-footer">
        <SheetActionButton
          variant="secondary"
          className="agro-simil-filters-sheet-clear-action"
          onClick={onClear}
        >
          Limpar
        </SheetActionButton>
        <SheetActionButton
          variant="confirm"
          className="agro-simil-filters-sheet-apply-action"
          onClick={dismiss}
        >
          {`Ver ${resultCount} ano${resultCount !== 1 ? 's' : ''}`}
        </SheetActionButton>
      </div>
    </BottomSheet>
  );
}
